import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FlexColumnStart } from '../common/forms/FormElements';

export const NavAction = ({ icon, label, onClick }) => (
    <FlexColumnStart
        component={Button}
        onClick={onClick}
        color="link"
        className="align-items-center p-2 tenant-icon"
    >
        <FontAwesomeIcon
            size="2x"
            icon={icon}
        />

        <small>
            {label}
        </small>
    </FlexColumnStart>
);